import { FC } from 'react';
import { Card, Progress , Empty} from "antd";
import Pentagon from '@pages/member-details/common/pentagon';
import Alphabet from '@pages/member-details/common/alphabet';
import DonutChart from "../donut-chart";
import './card.scss'
import DataNotFound from '@components/noDataFound';
import { NO_DATA_FOUND } from '../../../../constants/constants';

export interface SDCardProps {
  title: string
  class?: string
}

export const SDCard: FC<SDCardProps> = (props) => {
  return (
    <Card className={`ui-s-d-card ${props.class || ''}`}>
      <div className="ui-s-d-card__title">
        <span>
          {props.title}
        </span>
      </div>
      <div className="ui-s-d-card__content">
        {props.children}
      </div>
    </Card>
  )
}

export interface SDImageCardProps extends SDCardProps {
  image: React.ReactNode,
  value: string
}

export const SDImageCard: FC<SDImageCardProps> = (props) => {
  return (
    <SDCard {...(props as SDCardProps)}>
      <div className="ui-s-d-image-card__image">
        {props.image}
      </div>
      <div className="ui-s-d-image-card__value">
        {props.value}
      </div>
    </SDCard>
  )
}

export interface SDProgressCardProps extends SDCardProps {
  value: any
}

export const SDProgressCard: FC<SDProgressCardProps> = (props) => {
  return (
    <SDCard {...(props as SDCardProps)}>
      <div className="ui-s-d-progress-card__progress">
        <Progress
          type="circle"
          percent={props?.value ? props.value : 0}
          format={(percent)=> { return `${percent} %` }}
        />
      </div>
    </SDCard>
  )
}

export interface SDTextCardProps extends SDCardProps {
  text: string,
  subtext: string
}

export const SDTextCard: FC<SDTextCardProps> = (props) => {
  return (
    <SDCard {...(props as SDCardProps)}>
      {props.text ? (
        <>
          <div className="ui-s-d-text-card__text">{props.text}</div>
          <div className="ui-s-d-text-card__subtext">{props.subtext}</div>
        </>
      ) : (
        <DataNotFound message={NO_DATA_FOUND}/>
      )}
    </SDCard>
  )
}

export interface SDDonutCardProps extends SDCardProps {
  value: any,
  loading?: boolean
}

export const SDDonutCard: FC<SDDonutCardProps> = (props) => {
  return (
    <SDCard {...(props as SDCardProps)}>
      {props.value?.length <= 0 && !props.loading ? (
        <DataNotFound message={NO_DATA_FOUND} />
      ) : (
        <div className="ui-s-d-donut-card__donut">
          <DonutChart data={props.value} />
        </div>
      )}
    </SDCard>
  );
}

export interface SDPentagonCardProps extends SDCardProps {
  value: string
}

export const SDPentagonCard: FC<SDPentagonCardProps> = (props) => {
  return (
    <SDCard {...(props as SDCardProps)}>
      <div className="ui-s-d-pentagon-card__pentagon">
        <Pentagon value={props.value ? props.value : 0}/>
      </div>
    </SDCard>
  )
}

export interface SDAlphabetCardProps extends SDCardProps {
  value: string
}

export const SDAlphabetCard: FC<SDAlphabetCardProps> = (props) => {
  return (
    <SDCard {...(props as SDCardProps)}>
      <div className="ui-s-d-alphabet-card__alphabet">
        <Alphabet value={props.value ? props.value : 0}/>
      </div>
      <div className="ui-s-d-alphabet-card__value">
        <span>
          {props.value ? props.value : 0} %
        </span>
      </div>
    </SDCard>
  )
}

export interface SDEthnicityCardProps extends SDCardProps {
  items: Array<{
    name: string,
    percentage: number
    image: React.ReactNode
    color: string
  }>
}

export const SDEthnicityCard: FC<SDEthnicityCardProps> = (props) => {
  return (
    <SDCard {...(props as SDCardProps)}>
      <div className="ui-s-d-ethnicity-card__images">
        {
          props.items.map(
            item => {
              return Array.from(
                {
                  length: item.percentage / 5
                }
              ).map(
                (i) => item.image
              )
            }
          )
        }
      </div>
      <div className="ui-s-d-ethnicity-card__legends">
        {
          props.items.map(
            item => (
              <div className="ui-legend">
                <div className="ui-legend__color" style={{backgroundColor: item.color}}>
                </div>
                <div className="ui-legend__name">
                  {item.name}
                </div>
                <div className="ui-legend__percentage">
                  {item.percentage} %
                </div>
              </div>
            )
          )
        }
      </div>
    </SDCard>
  )
}
